// extracted by mini-css-extract-plugin
export var sliderRange = "_r0-2";
export var sliderRoot = "_r0-0";
export var sliderThumb = "_r0-3";
export var sliderTrack = "_r0-1";